import { message } from 'antd'

function createMarkup(error) {
  return { __html: error.response.status + ' ' + JSON.stringify(error.response.data) }
}

function MyComponent(error) {
  return <span dangerouslySetInnerHTML={createMarkup(error)} />
}

export default (error) => {
  message.config({
    top: 20,
    duration: 2,
    maxCount: 3,
  })
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    // message.error(MyComponent(error)).then((r) => {})
    message.error('Error code: '+error.response.status).then((r) => {})
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    message.error('Network Error').then((r) => {})
  } else if(error.message) {
    // Something happened in setting up the request that triggered an Error
    message.error('Error ' + error.message).then((r) => {})
  }else{
    message.error('Unknown Error').then((r) => {})
  }
}
